import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section className="about-section section">
      <div className="circuit-bg"></div>
      <div className="section-content">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <p className="about-text">
            Gentrobyte AI Labs - <span className="highlight">next-generation AI innovation company</span> delivering 
            intelligent software solutions for automation, digital transformation, and data-driven products.
          </p>
          <div className="focus-areas">
            <div className="focus-item">
              <div className="focus-icon">🤖</div>
              <div className="focus-name">AI-powered Software</div>
              <div className="focus-desc">Custom AI models and automation tools</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">📱</div>
              <div className="focus-name">Mobile Apps</div>
              <div className="focus-desc">Android and iOS app development</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">💻</div>
              <div className="focus-name">Web Apps</div>
              <div className="focus-desc">Scalable and responsive web solutions</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">🔄</div>
              <div className="focus-name">CRM & LMS</div>
              <div className="focus-desc">Enterprise-grade management systems</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">⚡</div>
              <div className="focus-name">Automation</div>
              <div className="focus-desc">Workflow and business process automation</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">☁️</div>
              <div className="focus-name">Cloud Solutions</div>
              <div className="focus-desc">Scalable and secure cloud infrastructure</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">🚀</div>
              <div className="focus-name">Digital Transformation</div>
              <div className="focus-desc">End-to-end digital modernization</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">🧠</div>
              <div className="focus-name">AI & Data Analytics</div>
              <div className="focus-desc">Intelligent insights from data</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">🔧</div>
              <div className="focus-name">DevOps & Cloud Infrastructure</div>
              <div className="focus-desc">Seamless deployment and scalability</div>
            </div>
            <div className="focus-item">
              <div className="focus-icon">🎨</div>
              <div className="focus-name">UI/UX Design</div>
              <div className="focus-desc">Intuitive and engaging product design</div>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
